import {
  PieChart as RechartsPieChart,
  Pie,
  Cell,
  ResponsiveContainer,
  Legend,
  Tooltip,
} from 'recharts';
import { useChartColors, useChartPalette } from '../../hooks/useChartColors';

interface PieChartProps {
  data: { name: string; value: number }[];
  colors?: string[];
  height?: number;
}

export function PieChart({ data, colors: colorsProp, height = 300 }: PieChartProps) {
  const chartColors = useChartColors();
  const defaultPalette = useChartPalette();
  const palette = colorsProp || defaultPalette;
  const total = data.reduce((sum, d) => sum + d.value, 0);

  return (
    <ResponsiveContainer width="100%" height={height}>
      <RechartsPieChart>
        <Pie
          data={data}
          cx="50%"
          cy="50%"
          innerRadius={65}
          outerRadius={90}
          paddingAngle={2}
          dataKey="value"
          animationDuration={750}
        >
          {data.map((_, index) => (
            <Cell key={`cell-${index}`} fill={palette[index % palette.length]} />
          ))}
        </Pie>
        <Tooltip
          contentStyle={{
            backgroundColor: chartColors.tooltipBg,
            border: `1px solid ${chartColors.tooltipBorder}`,
            borderRadius: '12px',
            boxShadow: '0 8px 32px rgba(0,0,0,0.2)',
            color: chartColors.text,
          }}
          formatter={(value: number) => [
            `${value.toLocaleString()} (${((value / total) * 100).toFixed(1)}%)`,
          ]}
        />
        <Legend
          layout="vertical"
          align="right"
          verticalAlign="middle"
          formatter={(value) => <span className="text-sm text-gray-600 dark:text-slate-300">{value}</span>}
        />
      </RechartsPieChart>
    </ResponsiveContainer>
  );
}
